(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('OfficeDeleteController',OfficeDeleteController);

    OfficeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Office'];

    function OfficeDeleteController($uibModalInstance, entity, Office) {
        var vm = this;
        vm.office = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Office.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
